import {
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import { useMutation, useQueryClient, useQuery } from "@tanstack/react-query";
import { Breadcrumbs, P, H6 } from "../../../../../AbstractElements";
import Cleave from "cleave.js/react";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { Btn } from "../../../../../AbstractElements";
import { useAppSelector } from "../../../../../ReduxToolkit/Hooks";
import ReactQuill from "react-quill-new";
import { Save } from "react-feather";
import Swal from "sweetalert2";

//TYPE AND SERVICES
import {
  APPLICANT_NOTES_QUERY_KEY,
  VIEW_APPLNOTES_QUERY_KEY,
  applicantNotesService,
} from "../../../../../Services/applicantsnotesService";

//INTERFACE
interface UpdateFormProps {
  toggle?: () => void;
  ApplNo: string;
}

const CreateNoteForm: React.FC<UpdateFormProps> = ({ toggle, ApplNo }) => {
  const queryClient = useQueryClient();
  const user = useAppSelector((state) => state.auth.user);

  const [formData, setFormData] = useState({
    application_no: ApplNo,
    notes: "",
    parent_id: null,
  });

  const createMutation = useMutation({
    mutationFn: (data: typeof formData) =>
      applicantNotesService.createNotes(data),
    onSuccess: (result) => {
      queryClient.invalidateQueries();
      if (toggle) toggle();
      Swal.close();
      Swal.fire({
        allowOutsideClick: false,
        allowEscapeKey: false,
        icon: "success",
        title: "Transaction Successful",
        text: result.message,
        confirmButtonColor: "#4e73df",
      });
    },
    onError: (error: any) => {
      const responseData = error.response?.data;
      Swal.close();
      Swal.fire({
        allowOutsideClick: false,
        allowEscapeKey: false,
        icon: "error",
        title: "Error",
        text: responseData?.message || "Failed to update attachment category.",
        confirmButtonColor: "#4e73df",
        
      });
    },
  });

  const handleNotesChange = (value: string) => {
    setFormData({
      ...formData,
      notes: value,
    });
  };
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // ReactQuill empty content is usually "<p><br></p>"
    const plainText = formData.notes.replace(/<[^>]*>/g, "").trim();

    if (!plainText) {
      toast.error("Remarks is required.");
      return;
    }

    Swal.fire({
        title: "Are you sure?",
        text: "Do you want to save this remarks?",
        icon: "question",
        showCancelButton: true,

        confirmButtonText: '<i class="fa fa-save"></i> Save Remarks',
        cancelButtonText: '<i class="fa fa-times"></i> Cancel',

        confirmButtonColor: "#4e73df", // Primary
        cancelButtonColor: "#dc3545",  // Danger
        allowOutsideClick: false,
        allowEscapeKey: false,

    }).then((result) => {
        if (result.isConfirmed) {
            Swal.fire({
                title: "Saving...",
                text: "Please wait while your remark is being save.",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    Swal.showLoading();
                },
            });

          createMutation.mutate(formData);
            
        }
    });

  };

  return (
    <Form className="needs-validation" onSubmit={handleSubmit}>
      <ModalBody>
        <Row className="g-3">
          <Col md="12">
            <Label>Enter your remarks or note: <b className="text-danger">*</b></Label>
            <ReactQuill value={formData.notes} onChange={handleNotesChange} style={{ height: "300px", marginBottom: "50px" }}/>
          </Col>
          
          <Col md="12 text-end">
            <Btn
              color="primary"
              type="submit"
              disabled={createMutation.isPending}
            >
              <Save size={16} className="me-1"/>
              {createMutation.isPending ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Creating Notes...
                </>
              ) : (
                "Save"
              )}
            </Btn>
          </Col>

        </Row>
      </ModalBody>
    </Form>
  );
};

export default CreateNoteForm;
